"use client"

import { type ReactNode, useEffect } from "react"
import { useRouter } from "next/navigation"

import {
  type AuthBroadcastChannelEvent,
  AuthChannelName,
  AuthContext,
  type AuthState,
} from "@/lib/auth/client"

type AuthrProviderOptions = {
  authState: AuthState
  children: ReactNode
}

export default function AuthProvider({
  children,
  authState,
}: AuthrProviderOptions) {
  const router = useRouter()
  useEffect(() => {
    const channel = new BroadcastChannel(AuthChannelName)
    if (!authState || !authState.user) return
    // if we have an auth state, we're logged in
    channel.postMessage({ loggedIn: true, authState })
    // if we're logged in and we get a message that we're logged out, then it's very likely that they logged out from another tab
    // so we should refresh just be sure
    channel.onmessage = (e: MessageEvent<AuthBroadcastChannelEvent>) => {
      if (!e.data.loggedIn) {
        router.refresh()
      }
    }
    return () => channel.close()
  }, [authState, router])
  return (
    <AuthContext.Provider value={authState}>{children}</AuthContext.Provider>
  )
}
